(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["coral-v2-article"]) return;
  try {
    
  (function () {
    var bar = document.getElementById('read-prog');
    var body = document.querySelector('.abody');
    function onScroll() {
      if (!body || !bar) return;
      var start = body.offsetTop - 120;
      var end = body.offsetTop + body.offsetHeight - window.innerHeight + 120;
      var p = (window.scrollY - start) / Math.max(1, end - start);
      bar.style.width = Math.max(0, Math.min(1, p)) * 100 + '%';
    }
    window.addEventListener('scroll', onScroll, { passive: true }); onScroll();
    document.addEventListener('click', function (e) {
      var c = e.target.closest('[data-copy-link]');
      if (c) { e.preventDefault(); if (navigator.clipboard) navigator.clipboard.writeText(location.href); if (window.CORAL) window.CORAL.toast('Link copied'); }
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["coral-v2-cart"]) return;
  try {
    
  (function () {
    document.addEventListener('click', function (e) {
      var inc = e.target.closest('[data-cart-inc]');
      var dec = e.target.closest('[data-cart-dec]');
      if (!inc && !dec) return;
      var row = e.target.closest('.crow'); if (!row) return;
      var input = row.querySelector('[data-cart-qty]'); if (!input) return;
      var val = parseInt(input.value, 10); if (isNaN(val)) val = 1;
      if (inc) val += 1; if (dec) val = Math.max(0, val - 1);
      input.value = val;
      var form = input.closest('form'); if (form) form.submit();
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["coral-v2-collection"]) return;
  try {
    
  (function () {
    /* Sort → reload with sort_by param (real Shopify sort) */
    document.addEventListener('change', function (e) {
      var sel = e.target.closest('[data-shop-sort]'); if (!sel) return;
      var url = new URL(window.location.href);
      url.searchParams.set('sort_by', sel.value);
      url.searchParams.delete('page');
      window.location.href = url.toString();
    });
    /* No client-side filter handler: filtering is Shopify storefront filtering
       (collection.filters), applied server-side. The old handler could only ever
       see the 24 cards on the current page, so both the results and the count
       were wrong past page 1. */
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["coral-v2-hero-banner"] && !Shopify.designMode) return;
  try {
    
  /* Full-vh budget: --hero-h = 100dvh - --hdr. The sticky header is real, so
     measure it (falls back to the CSS default 76px until this runs).
     Re-measured on resize and on theme-editor section reloads. */
  (function () {
    function setHdr() {
      var hero = document.querySelector('.ccr-hero');
      if (!hero) return;
      var header = document.querySelector('.header');
      hero.style.setProperty('--hdr', (header ? header.offsetHeight : 0) + 'px');
    }
    setHdr();
    window.addEventListener('resize', setHdr);
    document.addEventListener('shopify:section:load', setHdr);
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["coral-v2-herox"]) return;
  try {
    
  /* The crest layout budgets itself from --hero-h = 100dvh - --hdr. The design
     prototype had no site header and pinned --hdr to 0; here the sticky header
     is real, so measure it. Falls back to the CSS default (76px) until this
     runs. Re-measured on resize and on theme-editor section reloads. */
  (function () {
    function setHdr() {
      var hero = document.querySelector('.herox[data-herolayout="crest"]');
      if (!hero) return;
      var header = document.querySelector('.header');
      hero.style.setProperty('--hdr', (header ? header.offsetHeight : 0) + 'px');
    }
    setHdr();
    window.addEventListener('resize', setHdr);
    document.addEventListener('shopify:section:load', setHdr);
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["coral-v2-product"]) return;
  try {
    
  (function () {
    document.addEventListener('click', function (e) {
      var thumb = e.target.closest('[data-pdp-thumb]');
      if (thumb) {
        var gallery = thumb.closest('.gallery'); if (!gallery) return;
        var main = gallery.querySelector('[data-pdp-main]'); var full = thumb.getAttribute('data-full');
        if (main && full) main.src = full;
        gallery.querySelectorAll('[data-pdp-thumb]').forEach(function (t) { t.classList.toggle('active', t === thumb); });
        return;
      }
      var inc = e.target.closest('[data-pdp-inc]'); var dec = e.target.closest('[data-pdp-dec]');
      if (inc || dec) {
        var row = e.target.closest('.pinfo__buy'); if (!row) return;
        var input = row.querySelector('[data-pdp-qty]'); if (!input) return;
        var val = parseInt(input.value, 10); if (isNaN(val) || val < 1) val = 1;
        if (inc) val += 1; if (dec) val = Math.max(1, val - 1);
        input.value = val; return;
      }
      var head = e.target.closest('[data-pacc-head]');
      if (head) { var item = head.parentNode; var open = item.classList.toggle('open'); head.setAttribute('aria-expanded', open ? 'true' : 'false'); }
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["coral-v2-reviews"]) return;
  try {
    
  /* Google reviews reel.
     - Liquid renders only the real cards, so with JS off this degrades to a
       plain horizontally-scrollable row. JS clones them into a second, inert
       half and switches the marquee on.
     - Sorting and expanding are delegated from document so they survive
       theme-editor re-renders. */
  (function () {
    var SEL = '.grv';

    function realCards(track) {
      return [].slice.call(track.children).filter(function (n) {
        return n.hasAttribute && n.hasAttribute('data-grv-card') && !n.hasAttribute('data-grv-clone');
      });
    }

    function clearClones(track) {
      [].slice.call(track.querySelectorAll('[data-grv-clone]')).forEach(function (n) {
        n.parentNode.removeChild(n);
      });
    }

    /* Duplicate the row so translateX(-50% - gap/2) loops seamlessly. The copy is
       hidden from assistive tech and pulled out of the tab order — it is the same
       three reviews twice, not six. */
    function dress(track) {
      clearClones(track);
      var real = realCards(track);
      var rail = track.closest('[data-grv-rail]');
      var reel = track.closest('.grv__reel');
      var hint = reel && reel.querySelector('[data-grv-hint]');

      if (real.length < 2 || (rail && track.scrollWidth <= rail.clientWidth)) {
        track.classList.remove('is-marquee');
        if (hint) hint.hidden = true;
        return;
      }

      real.forEach(function (card) {
        var clone = card.cloneNode(true);
        clone.setAttribute('data-grv-clone', '');
        clone.setAttribute('aria-hidden', 'true');
        clone.removeAttribute('data-shopify-editor-block');
        [].slice.call(clone.querySelectorAll('a, button')).forEach(function (el) {
          el.setAttribute('tabindex', '-1');
        });
        track.appendChild(clone);
      });

      track.classList.add('is-marquee');
      if (hint) hint.hidden = false;
    }

    function num(el, attr) { return parseInt(el.getAttribute(attr), 10) || 0; }

    function sort(track, mode) {
      clearClones(track);
      var real = realCards(track);
      real.sort(function (a, b) {
        if (mode === 'newest') {
          var dy = num(b, 'data-year') - num(a, 'data-year');
          if (dy) return dy;
        } else if (mode === 'rating') {
          var ds = num(b, 'data-stars') - num(a, 'data-stars');
          if (ds) return ds;
        }
        return num(a, 'data-order') - num(b, 'data-order');
      });
      real.forEach(function (c) { track.appendChild(c); });
      dress(track);
    }

    function init(root) {
      [].slice.call((root || document).querySelectorAll('[data-grv-track]')).forEach(dress);
    }

    /* --- expand / collapse ------------------------------------------------ */
    function toggle(btn) {
      var card = btn.closest('[data-grv-card]');
      if (!card) return;
      var open = card.classList.toggle('is-open');
      btn.setAttribute('aria-expanded', open ? 'true' : 'false');

      var o = btn.querySelector('[data-grv-more-open]');
      var c = btn.querySelector('[data-grv-more-close]');
      if (o) o.hidden = open;
      if (c) c.hidden = !open;

      var reply = card.querySelector('[data-grv-reply]');
      if (reply) reply.hidden = !open;

      /* Hold the reel still while anything is expanded, so the card the reader
         just opened does not slide out from under them. */
      var rail = card.closest('[data-grv-rail]');
      if (rail) rail.classList.toggle('is-held', !!rail.querySelector('.grv__card.is-open'));
    }

    document.addEventListener('click', function (e) {
      var more = e.target.closest('[data-grv-more]');
      if (more) { e.preventDefault(); toggle(more); return; }

      var chip = e.target.closest('[data-grv-sort]');
      if (!chip) return;
      e.preventDefault();
      var reel = chip.closest('.grv__reel');
      var track = reel && reel.querySelector('[data-grv-track]');
      if (!track) return;
      [].slice.call(reel.querySelectorAll('[data-grv-sort]')).forEach(function (b) {
        var on = b === chip;
        b.classList.toggle('is-on', on);
        b.setAttribute('aria-pressed', on ? 'true' : 'false');
      });
      sort(track, chip.getAttribute('data-grv-sort'));
    });

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', function () { init(); });
    } else {
      init();
    }

    /* Theme editor swaps the section's DOM wholesale — re-clone into the new one. */
    document.addEventListener('shopify:section:load', function (e) {
      if (e.target && e.target.querySelector(SEL)) init(e.target);
    });

    var t;
    window.addEventListener('resize', function () {
      clearTimeout(t);
      t = setTimeout(function () { init(); }, 200);
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["coral-v2-videos"]) return;
  try {
    
  /* Click-to-load facade: swap the thumbnail button for a real embed only on demand.
     Delegated so it survives theme-editor section re-renders. */
  document.addEventListener('click', function (e) {
    var btn = e.target.closest('[data-yt]');
    if (!btn) return;
    var id = btn.getAttribute('data-yt');
    if (!id) return;
    var frame = document.createElement('iframe');
    frame.className = 'vcard__frame';
    frame.src = 'https://www.youtube-nocookie.com/embed/' + encodeURIComponent(id) +
                '?autoplay=1&rel=0&playsinline=1';
    frame.title = btn.getAttribute('aria-label') || 'YouTube video';
    frame.allow = 'accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture';
    frame.setAttribute('allowfullscreen', '');
    frame.setAttribute('loading', 'lazy');
    var shell = document.createElement('div');
    shell.className = 'vcard__media';
    shell.style.cursor = 'default';
    shell.appendChild(frame);
    btn.replaceWith(shell);
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky = this.getAttribute('data-sticky-type') === 'always' || this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      };

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => this.preventReveal = true;

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach(disclosure => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();
})();
